
export default [{
	path: '/contacts',
	component: () => import('@/components/contacts/List')
}]
